import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GlobalStyle } from './styles/GlobalStyle';
import { I18nProvider } from './contexts/I18nContext';
import Header from './components/Header';
import Home from './pages/Home';
import Chapters from './pages/Chapters';
import LevelDetail from './pages/LevelDetail';
import About from './pages/About';

function App() {
  return (
    <I18nProvider>
      <Router>
        <GlobalStyle />
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chapters" element={<Chapters />} />
              <Route path="/level/:levelId" element={<LevelDetail />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </main>
        </div>
      </Router>
    </I18nProvider>
  );
}

export default App;
